import { useNavigate } from "react-router";
import "./payment.scss";
import { useTranslation } from "react-i18next";
import { Paths } from "src/navigation";
import { submitCaptcha } from "src/ui/widgets";
import { useState } from "react";
import { usePostCertificate } from "src/networking/terminals";
import { useRecoilValue, useResetRecoilState } from "recoil";
import {
  atomDossier,
  atomEvaluatePremium,
  atomPolicy,
  atomQuestionnaire,
} from "src/storage";
import { fromBase64ToBlob } from "src/utils";

export const usePaymentOk = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const dossier = useRecoilValue(atomDossier);
  const policy = useRecoilValue(atomPolicy);
  const resetQuestionnaire = useResetRecoilState(atomQuestionnaire);
  const resetEvaluatePremium = useResetRecoilState(atomEvaluatePremium);

  const { crossGate: postCertificate } = usePostCertificate();
  const doPostCertificate = () => {
    if (!dossier?.dossierId || !policy?.idPolizza) {
      setLoading(false);
      return;
    }

    postCertificate(
      {
        headers: {
          xDossierId: dossier.dossierId,
          "Content-Type": "application/json",
        },
        queryParams: {
          codiceStampa: "CERT_GIVE",
        },
        uriParams: {
          idPolizza: policy?.idPolizza,
        },
      },
      {
        onSuccess: (certificate) => {
          if (certificate?.file && certificate?.fileName) {
            downloadCertificate(certificate.file, certificate.fileName);
          }
          resetQuestionnaire();
          resetEvaluatePremium();
        },
        onPending: () => {},
        onIdle: () => setLoading(false),
      }
    );
  };

  const generateRecaptcha = async () => {
    await submitCaptcha().then(() => {
      setLoading(true);
      setTimeout(doPostCertificate, 7000);
    });
  };

  const navigateToHome = () => {
    navigate(Paths.Landing);
  };

  const downloadCertificate = (base64file: string, fileName: string) => {
    const blob = fromBase64ToBlob(base64file);
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return {
    loading,
    t,
    navigateToHome,
    generateRecaptcha,
  };
};
